import React, { FC } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayRules } from '../../hooks/useGiveawayRules'
import { GFooterMD } from '../UI/Typography'

interface GiveawayRulesContentProps {
  theatricalSlug: string
}

export const GiveawayRulesContent: FC<GiveawayRulesContentProps> = ({ theatricalSlug }) => {
  const { t } = useTranslate('tickets')
  const { rulesConfig, hasRules } = useGiveawayRules(theatricalSlug)

  if (!hasRules || !rulesConfig) {
    return null
  }

  return <GFooterMD color="white">{rulesConfig.content(t)}</GFooterMD>
}
